import { sendGTMEvent } from "@next/third-parties/google";
import { VALID_GTM_EVENT_NAMES } from "@/constants/constants";
// test commit

class AnalyticsUtil {
  /**
   * Sends a GTM event
   * @param eventName - The name of the event
   * @param eventData - Additional data related to the event
   */
  static triggerEvent<T>(eventName: string, eventData: Record<string, T> = {}): void {
    if (!Object.values(VALID_GTM_EVENT_NAMES).includes(eventName)) {
      console.error(`Invalid GTM event name: "${eventName}".`);
      return;
    }
    try {
      sendGTMEvent({
        event: eventName,
        ...eventData,
      });
      console.log(`GTM Event Triggered: ${eventName}`, eventData);
    } catch (error) {
      console.error("Failed to send GTM event:", error);
    }
  }
}

export default AnalyticsUtil;
